import { useState, useEffect } from "react";
import { HBAW_HOST } from "@/utils/constants";

const useHbaw = () => {
  const [isHbaw, setIsHbaw] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.host === HBAW_HOST) {
      setIsHbaw(true);
    }
  }, []);

  return {
    isHbaw,
  };
};

export default useHbaw;
